var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/_coreJsData.js
// module id = 152
// module chunks = 0